import DepartmentsFilter from "./DepFilter";
export default DepartmentsFilter;
